<template>
  <div class="contain">
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 5px">
      <div style="color: #606266; font-size: 14px; word-break: break-all">
        {{ $t('* 언어 변경후 카테고리, 재료, 옵션 그룹, 옵션, 할인, 메뉴 데이타도 같이 수정 해주셔야 합니다.') }}
      </div>

      <!--
        요약줄 chip 은 **축마다** 하나다 — 콜팝 참여(`participation`)와 채널(`view.links`)을 `partnerChipKeys`
        한 곳이 순서까지 정한다. 축을 하나로 고정하면 두 번째 축이 요약줄에서 통째로 사라진다.
        클릭은 종전대로 탭 이동이다.
      -->
      <div v-if="hasTab('partner') && inputForm && inputForm.storeCd" class="partner-chips">
        <PartnerLinkChip
          v-for="key in partnerChipKeys"
          :key="key"
          :view="partnerLinkView"
          :partner="key"
          @select="activiTabStore = 'partner'" />
      </div>

      <el-popover placement="right" v-model="showQrPopup" @show="showQr(inputForm.storeId)">
        <el-row class="modal-content-qr">
          <el-col :md="12" class="qr-wrapper">
            <div>{{ $t('매장 정보 QR') }}</div>
            <div :id="'storeId_' + inputForm.storeId" style="padding: 20px"></div>
            <div>{{ getStoreInfoQr(inputForm.storeId) }}</div>
          </el-col>
          <el-col :md="12" class="qr-wrapper">
            <div>{{ $t('매장 배달  QR') }}</div>
            <div :id="'storeId_O_' + inputForm.storeId" style="padding: 20px"></div>
            <div>{{ getOutQr(inputForm.storeId) }}</div>
          </el-col>
          <el-col :span="24" style="margin-top: 10px">
            <el-button size="small" text @click="showQrPopup = false">{{ $t('닫기') }}</el-button>
          </el-col>
        </el-row>
        <el-button :size="size" slot="reference">{{ $t('QR보기') }}</el-button>
      </el-popover>
    </div>

    <el-form
      :model="inputForm"
      :label-width="$device.mobile ? `` : `180px`"
      label-suffix=":"
      :label-position="$device.mobile ? `top` : ``"
      :size="size"
      @submit.native.prevent>
      <!-- 매장 폼의 탭은 세 화면이 같은 컴포넌트로 그린다(`StoreFormTabs`) — 이 화면의 탭(외부 채널·TV 쿠폰)만 뒤에 붙인다 -->
      <StoreFormTabs
        v-model="activiTabStore"
        :form="inputForm"
        :formError="formError"
        :deliveryAgencyOptions="deliveryAgencyOptions"
        :brandCodeOptionsMap="brandCodeOptionsMap"
        @form-error-update="
          ({ key, value }) => {
            formError[key] = value
          }
        "
        @addDeliveryFee="addDeliveryFee"
        @removeDeliveryFee="removeDeliveryFee"
        @addDeliveryAgency="addDeliveryAgency"
        @removeDeliveryAgency="removeDeliveryAgency">
        <el-tab-pane
          v-if="hasTab('partner') && inputForm && inputForm.storeCd"
          :label="$t('외부 채널 연동')"
          name="partner">
          <PartnerLinkPanel
            :storeCd="inputForm.storeCd"
            :reload-seq="partnerLinkReloadSeq"
            @updated="partnerLinkView = $event" />
        </el-tab-pane>

        <!--
          우리동네TV 쿠폰(R-C) — 매장 계정의 진입점이다(서버 SQL 032 에 메뉴 행이 없어 이 화면의 탭으로 둔다).
          매장 저장 신호(`partnerLinkReloadSeq`)로 다시 읽는다 — 사업자번호가 바뀌면 발행 자격이 바뀐다.
        -->
        <el-tab-pane
          v-if="hasTab('tvCoupon') && inputForm && inputForm.storeCd"
          :label="$t(tvCouponTabTitle)"
          name="tvCoupon"
          lazy>
          <TvCouponPanel :storeCd="inputForm.storeCd" :reload-seq="partnerLinkReloadSeq" />
        </el-tab-pane>
      </StoreFormTabs>
    </el-form>

    <div slot="footer" class="dialog-footer" style="text-align: right">
      <el-button @click="save" icon="el-icon-check" :size="size" :disabled="btn.saveDisabled">{{
        $t('저장')
      }}</el-button>
    </div>
    <!-- </el-dialog> -->
  </div>
</template>

<script>
import PartnerLinkChip from '@/components/store/PartnerLinkChip.vue'
import PartnerLinkPanel from '@/components/store/PartnerLinkPanel.vue'
import StoreFormTabs from '@/components/store/StoreFormTabs.vue'
import TvCouponPanel from '@/components/store/TvCouponPanel.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import { storeFormMixin } from '@/mixins/storeFormMixin'
import { initData } from '@/utils/constants'
import { partnerChipKeys } from '@/utils/partnerLink'
import { storeFormTab } from '@/utils/storeDetailForm'
import { storeInfoTabs } from '@/utils/storeInfoTabs'
import { TV_COUPON_TEXT } from '@/utils/tvCoupon'

export default {
  mixins: [mainVueMixin, storeFormMixin],

  components: {
    PartnerLinkChip,
    PartnerLinkPanel,
    StoreFormTabs,
    TvCouponPanel,
  },

  data() {
    var data = initData()
    data.url = '/store/info'
    data.activiTabStore = 'info'
    data.imgList = []
    data.showImgSelect = true
    data.storeTp = []
    data.bankTp = []
    data.menuShowTp = []
    data.globalVatTp = []
    data.globalServiceCostTp = []
    data.showQrPopup = false
    /**
     * 요약줄 chip 이 읽는 `PartnerLinkView` — 출처는 탭의 `PartnerLinkPanel` 하나다(`updated`). 여기서 따로 조회하지
     * 않는다: 같은 사실에 로더가 둘이면 같은 화면의 chip 과 패널이 어긋날 수 있다.
     */
    data.partnerLinkView = null
    /** 매장 저장 뒤 패널을 다시 읽게 하는 신호(`onStoreSaved`) */
    data.partnerLinkReloadSeq = 0
    data.tvCouponTabTitle = TV_COUPON_TEXT.tabTitle

    // data.pgKindList =
    // data.inputForm = this.initInputForm()
    // data.formError = this.initFormError()

    // 저장은 **상세를 읽은 뒤**부터다 — `up()` 성공이 푼다. 열자마자 누르면 대상 매장이 없어
    // 보낼 곳이 없는 요청이 된다(`initData()` 기본값이 잠금이라 여기서 따로 풀지 않는다)
    data.deliveryAgencyOptions = []
    data.brandCodeOptionsMap = {}

    return data
  },
  computed: {
    /**
     * 요약줄이 그릴 chip 들 — 참여 축 + 서버가 내린 채널 목록이고 그 조립은 `utils/partnerLink` 가 한다.
     * 조회 전·실패는 빈 배열이라 아무것도 그리지 않는다.
     */
    partnerChipKeys() {
      return partnerChipKeys(this.partnerLinkView)
    },
    /**
     * 이 화면의 탭 이름 — 매장 폼의 탭 뒤에 **이 세션이 여는** 이 화면의 탭(`utils/storeInfoTabs`). 믹스인의 같은 이름을 덮어쓴다.
     * 탭·요약줄 chip 의 `v-if`([hasTab])와 처음 탭(`?tab=`)이 이 목록 하나를 읽는다.
     */
    storeFormTabs() {
      return storeInfoTabs(this.checkAuthActionAccess)
    },
  },
  created: function () {
    // 이 화면은 자기 매장 하나를 **고치기만** 한다 — `up()` 이 상세로 덮기 전의 빈 폼도 수정이다
    this.inputForm = this.initInputForm({ statu: 'U' })
    this.formError = this.initFormError()
    // 처음 펼칠 탭은 주소가 고른다(`?tab=<pane name>` — POS2 Lite 「플레이스 연동」 카드가 「외부 채널 연동」을 바로 연다).
    // 모르는 값·이 세션에 없는 탭은 첫 탭이다. 그 pane 은 상세(`storeCd`)를 읽은 뒤에 생기지만 생기는 순간 펼쳐진다
    this.activiTabStore = storeFormTab(this.$route.query.tab, this.storeFormTabs)

    this.initBankTp()
    this.initMenuShowTp()
    this.initGlobalVatTp()
    this.initGlobalServiceCostTp()
    this.initDeliveryAgencyData()
    this.up()
  },
  methods: {
    /** 이 세션에 그 탭이 있는가 — [storeFormTabs] 가 답한다(어느 탭을 어느 액션이 여는가는 `utils/storeInfoTabs` 한 곳) */
    hasTab(name) {
      return this.storeFormTabs.indexOf(name) > -1
    },
    /**
     * 저장 성공 뒤(mixin 훅) — 이 화면(매장 관리자의 「매장 정보 관리」)은 목록도 다이얼로그도 없다.
     *
     * 할 일 셋: 알림 설정을 셸에 반영하고(주문 알림음), 주문 알림 스위치대로 웹소켓을 다시 열거나 닫고,
     * 연동 뷰를 다시 읽는다 — 사업자번호·전화·매장명이 바뀌었을 수 있어 그러지 않으면 신청 확인창과
     * 차단 사유가 저장 전 값으로 남는다(§1.3 1번: 보내는 값을 보여 주고 확인받는다).
     */
    onStoreSaved({ method }) {
      this.mainVue.$message({ type: 'success', message: this.$t('add' === method ? '등록 성공' : '수정 성공') })
      this.activiTabStore = 'info'

      this.mainVue.alarmYn = this.inputForm.alarmYn

      if (this.inputForm.orderNoti) {
        this.mainVue.initWebSocket()
      } else {
        this.mainVue.websock.close()
      }

      this.partnerLinkReloadSeq += 1
    },
  },
}
</script>

<style scoped>
.el-upload-list__item {
  -webkit-transition: none;
  transition: none;
}

/* 요약줄 chip — 채널이 여럿이면 가로로 나열하고 좁으면 접힌다(요약줄이 제목을 밀어내지 않게) */
.partner-chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 2px;
}

.file_name .el-textarea__inner {
  height: 90px;
}

.grid-title {
  font-size: 16px;
}

.modal-content-qr {
  width: 500px;

  text-align: center;
}
@media (max-width: 768px) {
  .grid-title {
    font-size: 12px;
  }

  .modal-content-qr {
    width: 100%;
  }

  .modal-content-qr .el-col + .el-col {
    margin-top: 30px;
  }
}

.qr-wrapper {
  padding: 10px;
}
</style>
